module.exports = __webpack_public_path__ + "img/center_text13.e60b279e.png";